import { render, staticRenderFns } from "./PanelCompetitionLanguagesForm.vue?vue&type=template&id=2331c02e&scoped=true&"
import script from "./PanelCompetitionLanguagesForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionLanguagesForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionLanguagesForm.vue?vue&type=style&index=0&id=2331c02e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2331c02e",
  null
  
)

export default component.exports